const RECENTLY_VIEWED_STORAGE_KEY = 'lrRecentlyViewedProducts';
const LEGACY_RECENTLY_VIEWED_STORAGE_KEY = 'globoRecentlyViewedProducts';
const max_results = 8;
const max_stored_products = 20;
let viewed_products;

initialiseRecentlyViewed();

async function initialiseRecentlyViewed() {
    await syncRecentlyViewedStorage();
    viewed_products = buildViewedProducts(readStoredRecentlyViewedProducts());
}

async function syncRecentlyViewedStorage() {
    migrateLegacyStorage();

    if (!isProductPage()) {
        return;
    }

    const productHandle = getProductHandleFromPath();
    if (!productHandle) {
        return;
    }

    try {
        const response = await fetch(`${window.location.origin}/products/${productHandle}.js`);
        if (!response.ok) {
            return;
        }

        const product = await response.json();
        const normalizedProduct = normaliseStoredProduct(product);
        if (!normalizedProduct) {
            return;
        }

        const existingProducts = readStoredRecentlyViewedProducts()
            .filter((storedProduct) => storedProduct.handle !== normalizedProduct.handle);

        existingProducts.unshift(normalizedProduct);
        writeStoredRecentlyViewedProducts(existingProducts.slice(0, max_stored_products));
    } catch (error) {
        console.warn('Failed to update recently viewed storage.', error);
    }
}

function buildViewedProducts(recentlyViewed) {
    const products = [];

    if (!Array.isArray(recentlyViewed)) {
        return products;
    }

    for (let i = 0; i < recentlyViewed.length; i++) {
        if (products.length >= max_results) {
            break;
        }

        const product = recentlyViewed[i];
        if (!product || !product.handle || !Array.isArray(product.images) || product.images.length === 0) {
            continue;
        }

        const variants = Array.isArray(product.variants) ? product.variants : [];
        const newProduct = {
            title: product.title,
            num_variants: variants.length || 1,
            main_image: product.images[0],
            product_url: getProductURL(product.handle),
            price_from: null,
            price_to: null,
            price: null,
            on_sale: product.compare_at_price !== null && product.compare_at_price > product.price
        };

        if (variants.length >= 2) {
            const variantPrices = variants
                .map((variant) => parseInt(variant.price, 10))
                .filter((price) => !Number.isNaN(price));

            if (variantPrices.length) {
                newProduct.price_from = formatPrice(Math.min(...variantPrices));
                newProduct.price_to = formatPrice(Math.max(...variantPrices));
            }
        }

        if (!newProduct.price_from || !newProduct.price_to) {
            newProduct.price = formatPrice(product.price);
        }

        products.push(newProduct);
    }

    return products;
}

function readStoredRecentlyViewedProducts() {
    return safeParseStorage(RECENTLY_VIEWED_STORAGE_KEY) || safeParseStorage(LEGACY_RECENTLY_VIEWED_STORAGE_KEY) || [];
}

function writeStoredRecentlyViewedProducts(products) {
    localStorage.setItem(RECENTLY_VIEWED_STORAGE_KEY, JSON.stringify(products));
}

function migrateLegacyStorage() {
    const currentProducts = safeParseStorage(RECENTLY_VIEWED_STORAGE_KEY);
    if (Array.isArray(currentProducts) && currentProducts.length) {
        return;
    }

    const legacyProducts = safeParseStorage(LEGACY_RECENTLY_VIEWED_STORAGE_KEY);
    if (Array.isArray(legacyProducts) && legacyProducts.length) {
        writeStoredRecentlyViewedProducts(legacyProducts);
    }
}

function safeParseStorage(storageKey) {
    try {
        const rawValue = localStorage.getItem(storageKey);
        return rawValue ? JSON.parse(rawValue) : null;
    } catch (error) {
        console.warn(`Failed to parse localStorage for ${storageKey}.`, error);
        return null;
    }
}

function isProductPage() {
    return document.body?.dataset.template === 'product' && /^\/products\//.test(window.location.pathname);
}

function getProductHandleFromPath() {
    const pathMatch = window.location.pathname.match(/^\/products\/([^/?#]+)/);
    return pathMatch ? pathMatch[1] : null;
}

function normaliseStoredProduct(product) {
    if (!product || !product.handle || !Array.isArray(product.images) || product.images.length === 0) {
        return null;
    }

    return {
        handle: product.handle,
        title: product.title,
        price: product.price,
        compare_at_price: product.compare_at_price,
        images: product.images,
        variants: Array.isArray(product.variants)
            ? product.variants.map((variant) => ({
                price: variant.price
            }))
            : []
    };
}

function getProductPrice(arrayID) {
    return viewed_products[arrayID].price ? currencySymbol() + viewed_products[arrayID].price : `${currencySymbol() +viewed_products[arrayID].price_from } - ${currencySymbol() + viewed_products[arrayID].price_to }`;
}

function formatPrice(price) {
    let convertedPrice = (price/100.0).toFixed(2);
    
    let parts = convertedPrice.split('.');
    let dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + ',');
    let cents = parts[1] ? ('.' + parts[1]) : '';

    return dollars + cents;
}

function currencySymbol() {
    return document.getElementById('recently-viewed-container').dataset.currencySymbol;
}

function getProductURL(handler) {
    let rootDomain = window.location.origin;
    return `${rootDomain}/products/${handler}`;
}
